import {grayColor, main} from "../../Lib/material-kit/assets/jss/material-kit-pro-react.jsx";
import {primaryColor} from "../../Lib/material-dashboard/assets/jss/material-dashboard-pro-react";

export const contentBoxStyle = {
  main: {
    ...main,
    width: "100%",
    backgroundColor: grayColor[2],
    "@media (min-width: 576px)": {
      paddingLeft: 30,
      paddingRight: 30,
    },
    height: "100vh",
    minHeight: "100vh",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column"
  },
  titleContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: "44px",
    minHeight: "44px",
    maxHeight: "44px",
    overflowY: "hidden",
    "@media (max-width: 576px)": {
      paddingLeft: 10,
    },
  },
  title : {
    color: "rgb(12,66,105)", //"#396593",
    fontWeight: 600,
    "&:hover,&:focus": {
      color: primaryColor
    },
  },
  addBtn: {
    margin: "0 0 0 15px",
  },
  content : {
    flexGrow: "1",
    display: "flex",
    flexDirection: "column"
  }
};